import { DataSourceType } from "./types";

/**
 * Get file extension from filename
 */
export const getFileExtension = (filename: string): string => {
  return filename.split(".").pop()?.toLowerCase() || "";
};

/**
 * Get file icon based on file type
 */
export const getFileIcon = (type: string): string => {
  if (!type) return "insert_drive_file";
  if (type === "pdf") return "picture_as_pdf";
  if (type === "docx" || type === "doc") return "description";
  if (type === "xlsx" || type === "xls") return "table_chart";
  if (["png", "jpg", "jpeg", "gif"].includes(type)) return "image";
  return "insert_drive_file";
};

/**
 * Get content preview with character limit
 */
export const getContentPreview = (content: string, limit = 20): string => {
  const text = content || "";
  return text.length > limit ? `${text.slice(0, limit)}...` : text;
};

/**
 * Extract display name from attachment path
 * Format: uuid_originalname.ext -> originalname.ext
 */
export const getDisplayName = (attachment: string): string => {
  const fileName = attachment.split("/").pop() || attachment;
  return fileName.includes("_")
    ? fileName.substring(fileName.indexOf("_") + 1)
    : fileName;
};

/**
 * Map API response to DataSourceType
 */
export const mapApiToDataSource = (item: any): DataSourceType => {
  const attachments =
    item.attachments ||
    item.dataSourceAttachments ||
    item.dataSourceFiles ||
    [];

  const files = Array.isArray(attachments)
    ? attachments.map((attachment: string, index: number) => {
        const fileName = attachment.split("/").pop() || attachment;
        return {
          id: `f${index + 1}`,
          name: getDisplayName(attachment),
          size: "",
          type: getFileExtension(fileName),
          url: attachment,
        };
      })
    : undefined;

  return {
    id: String(item.dataSourceId ?? item.id ?? crypto.randomUUID()),
    title: item.dataSourceTitle ?? item.title ?? "",
    version: item.dataSourceVersion ?? item.version ?? "",
    content: item.dataSourceContent ?? item.content ?? "",
    files,
  };
};
